import React, { useMemo } from 'react';
import Helmet from 'react-helmet';
import { setParam } from '../../utils/helper';
import { langCodeAllowed } from '../../locales';

const COUNTRY = 'sg';
const LANG = 'en';

const CategoryHelmet = props => {
  const {
    location,
    categoryData,
    LISTING_PAGE_SIZE,
    pathname,
    currUrl,
    pageParam,
    localeInfo = {},
  } = props;
  console.log('category data ===>', categoryData);
  const { product_list, breadcrumb, num_of_products, seo_meta_keywords } = categoryData;
  const { domainUrl, domain } = localeInfo;
  const listSchema =
    (product_list &&
      product_list.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.product_url,
          name: `${item.brand_name} ${item.model_name}`,
          image: item.image_url,
        };
      })) ||
    [];
  const bCrumbSchema =
    (breadcrumb &&
      breadcrumb.map((item, index) => {
        return (
          item.link && {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': `${domain}/${String(item.link)
                .replace(`${domainUrl}`, '')
                .replace('mobile/', '')}`,
              name: item.label,
            },
          }
        );
      })) ||
    [];
  let hrefLink =
    pageParam >= 1 && (pageParam + 1) * LISTING_PAGE_SIZE < num_of_products
      ? setParam(`${localeInfo.domain}${pathname}`, 'page', pageParam + 1)
      : `${localeInfo.domain}${pathname}`;
  hrefLink = location.search ? `${localeInfo.domain}${pathname}${location.search}` : hrefLink;
  const keysArray = Object.keys(langCodeAllowed);
  const locale = domain.includes(`/${COUNTRY}/${LANG}`) ? '' : `/${COUNTRY}/${LANG}`;
  const linkArray = [
    {
      rel: 'next',
      id: 'next-page',
      href:
        pageParam >= 0 && (pageParam + 1) * LISTING_PAGE_SIZE < num_of_products
          ? setParam(currUrl, 'page', pageParam + 1)
          : `${domain}${pathname}`,
    },
    {
      rel: 'prev',
      id: 'prev-page',
      href:
        pageParam > 1 && (pageParam - 1) * LISTING_PAGE_SIZE < num_of_products
          ? setParam(currUrl, 'page', pageParam - 1)
          : `${domain}${pathname}`,
    },
    { rel: 'alternate', href: `${domain}${pathname}` },
    { rel: 'canonical', href: `${domain}${locale}${pathname}` },
  ];
  keysArray.forEach(keys => {
    if (keys === 'sg') {
      linkArray.push({
        rel: 'alternate',
        hrefLang: `${langCodeAllowed[keys]?.hrefLang}`,
        href: hrefLink,
      });
    }
  });
  const title = useMemo(() => {
    if (!categoryData?.category_name) return '';

    const titles = {
      Eyeglasses: 'Eyeglasses & Spectacle Frames | OWNDAYS ONLINE STORE - OPTICAL SHOP',
      Sunglasses: 'Sunglasses with 100% UV Protection | OWNDAYS ONLINE STORE - OPTICAL SHOP',
      'New Arrivals': 'New Arrivals | Discover the Latest Styles | OWNDAYS',
      'Eyeglasses New Arrivals': 'Eyeglasses New Arrivals | Latest Styles | OWNDAYS',
    };
    return titles[categoryData?.category_name] || '';
  }, [categoryData]);

  const description = useMemo(() => {
    if (!categoryData?.category_name) return '';

    const descriptions = {
      Eyeglasses:
        'Shop eyeglasses, transparent spectacles, square frames and frameless designs at OWNDAYS. All come with UV protection and dust-repellent high-index lenses.',
      Sunglasses:
        'OWNDAYS sunglasses store features 100% UV protection and dust-repellent lenses, starting from $20. Enjoy stylish designs with clear vision & lasting comfort.',
      'New Arrivals':
        'All OWNDAYS spectacles come with high index aspheric lenses that have dust-repellent coating and offer UV protection. Find your perfect pair of spectacles in OWNDAYS.',
      'Eyeglasses New Arrivals':
        'All OWNDAYS spectacles come with high index aspheric lenses that have dust-repellent coating and offer UV protection. Find your perfect pair of spectacles in OWNDAYS.',
    };

    return descriptions[categoryData?.category_name] || '';
  }, [categoryData]);

  const metaArray = [
    {
      name: 'description',
      content: description,
    },
    {
      name: 'keywords',
      content:
        'Frames,Spectacle,Sunglasses,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,eyewear Singapore,pc lenses',
    },
    { name: 'robots', content: 'INDEX,FOLLOW' },
    { name: 'author', content: 'OWNDAYS' },
    { name: 'publisher', content: 'OWNDAYS' },
    { property: 'og:site_name', content: 'owndays.com' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: `${domain}${pathname}` },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:image',
      content: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:site', content: '@ODsingapore' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    {
      name: 'twitter:image',
      content: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    },
  ];
  // if (localeInfo.countryCode === 'sg') {
  //   metaArray = metaArray.filter(item => item.name !== 'robots');
  // }

  return (
    <Helmet
      link={linkArray}
      meta={metaArray}
      script={[
        ...(listSchema.length
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'ItemList',
                  itemListElement: listSchema,
                }),
              },
            ]
          : []),
        ...(bCrumbSchema.length
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'BreadcrumbList',
                  itemListElement: bCrumbSchema,
                }),
              },
            ]
          : []),
      ]}
      title={title}
    ></Helmet>
  );
};

export default CategoryHelmet;
